import { Component } from '@angular/core';
import { StandardPageLayoutComponent } from '@layouts/standard-page/standard-page.component';
import { Icons } from '@atoms/icon/icon.component';
import { SharedCommonModule } from '@shared/common.module';
import { RouterOutlet } from '@angular/router';
import { EduPageMenuComponent } from '@compound/menus/page-menu/page-menu.component';
import { item, MenuItemContent } from '@compound/menus/types';

export interface SettingsGroup {
  nameKey: string;
  icon: Icons;
  routerLink: string;
}

@Component({
  templateUrl: './settings.component.html',
  imports: [StandardPageLayoutComponent, SharedCommonModule, RouterOutlet, EduPageMenuComponent],
})
export class SettingsPageComponent {
  public Icons = Icons;

  public settingsMenuItems: MenuItemContent[] = [
    item({
      label: 'routes.internal.settings.groups.account.name',
      icon: Icons.PARTICIPANTS,
      route: '/settings/account',
    }),
    item({
      label: 'routes.internal.settings.groups.branding.name',
      icon: Icons.CUSTOMIZED,
      route: '/settings/branding',
    }),
    item({
      label: 'routes.internal.settings.groups.security.name',
      icon: Icons.ENCRYPTED,
      route: '/settings/security',
    }),
    item({
      label: 'routes.internal.settings.groups.api.name',
      icon: Icons.SLIDER,
      route: '/settings/api',
    }),
    item({
      label: 'routes.internal.settings.groups.billing.name',
      icon: Icons.MONETIZATION,
      route: '/settings/billing',
    }),
  ];
}
